import React from 'react';
import { Modal, Button } from '@unite-us/app-components';
import { ON_PLATFORM_REFERRALS, OFF_PLATFORM_REFERRALS, GROUPED_REFERRALS_EXPLANATION, UNGROUP_REFERRAL_EXPLANATION, GROUPED_REFERRAL_MUST_HAVE_SAME } from './constants';
var AboutGroupedReferralsModal = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var onClose = _ref.onClose;
  return /*#__PURE__*/React.createElement(Modal, {
    ref: ref,
    title: "Learn more about referrals",
    customSize: {
      width: '800px'
    },
    customStyle: {
      transform: 'translate3d(-50%, -50%, 0px)'
    },
    modal: true,
    showBorderRadius: true,
    modalContentStyles: {
      position: 'fixed',
      top: '50%',
      left: '50%'
    },
    onRequestClose: onClose,
    actions: /*#__PURE__*/React.createElement("div", {
      className: "confirmation-dialog__actions"
    }, /*#__PURE__*/React.createElement("span", {
      className: "mr-4 inline-block"
    }, /*#__PURE__*/React.createElement(Button, {
      label: "Cancel",
      onClick: onClose
    })))
  }, /*#__PURE__*/React.createElement("div", {
    className: "min-h-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-10"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "text-xl mb-2 font-bold"
  }, "On-Platform Referrals"), ON_PLATFORM_REFERRALS), /*#__PURE__*/React.createElement("div", {
    className: "mb-10"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "text-xl mb-2 font-bold"
  }, "Off-Platform Referrals"), OFF_PLATFORM_REFERRALS), /*#__PURE__*/React.createElement("div", {
    className: "mb-10"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "text-xl mb-2 font-bold"
  }, "Grouped Referrals"), GROUPED_REFERRALS_EXPLANATION, /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-2 gap-4 m-4"
  }, GROUPED_REFERRAL_MUST_HAVE_SAME.map(function (item) {
    return /*#__PURE__*/React.createElement("li", {
      key: item
    }, item);
  })), UNGROUP_REFERRAL_EXPLANATION)));
});
export default AboutGroupedReferralsModal;
//# sourceMappingURL=AboutGroupedReferralsModal.js.map